/** Tvar avatara */
export enum Shape {
    /** Čtverec */
    square = "square",
    /** Kruh */
    circle = "circle",
    /** Zaoblený čtverec */
    roundedSquare = "roundedSquare",
}

export enum AvatarSize {
    small = "small",
    medium = "medium",
    large = "large",
}

/**
 * Typ zobrazeného loaderu
 */
export enum LoaderType {
    progressBar = "progressBar",
    spinner = "spinner",
}
